import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import { BrowserRouter } from "react-router-dom";
import OrientationModal from "./Component/OrientationModal";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
	
	<BrowserRouter>
		<OrientationModal>
			<StrictMode>
				<App />
			</StrictMode>
		</OrientationModal>
	</BrowserRouter>
);
